var _circle, _circle2, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _g3, _path9, _g4, _path10, _g5, _path11, _g6, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_413",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_413)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.112 27H31.752C29.1278 27 27 29.1278 27 31.752V88.248C27 90.8722 29.1278 93 31.752 93H88.248C90.8722 93 93 90.8722 93 88.248V57.888H62.112V27Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8198 35.4708C50.8741 35.7322 50.3804 35.9936 49.335 38.6072C48.5509 40.5238 44.5434 50.2522 43.1204 53.8532H42.1621C40.4487 49.1777 37.9513 42.3824 36.296 38.0844C35.4829 35.9355 34.9892 35.6451 33.2178 35.4708V34.6577H40.5939V35.4708C38.445 35.7032 38.3288 36.0516 38.7354 37.1261C39.4614 39.246 41.5813 45.025 43.4108 49.8456C44.9499 46.0995 46.8666 41.366 48.2315 37.7069C48.8703 36.0226 48.5219 35.7612 46.1406 35.4708V34.6577H52.8198V35.4708Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0596 86.5069V85.6937C41.4409 85.4324 41.6732 85.3162 41.6732 82.8478V71.3189C41.6732 68.8215 41.4409 68.7053 39.0596 68.444V67.6309H46.841V68.444C44.4306 68.7053 44.1983 68.8215 44.1983 71.3189V82.8478C44.1983 85.3453 44.4306 85.4324 46.841 85.6937V86.5069H39.0596Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7368 81.8461C85.3302 83.24 84.5752 85.3309 84.1396 86.2312C83.2974 86.3764 81.0323 86.9281 78.8252 86.9281C71.8847 86.9281 68.3418 82.1365 68.3418 77.2288C68.3418 71.0142 72.9301 67.21 79.4932 67.21C81.8744 67.21 83.8782 67.7617 84.8365 67.8779C84.9527 69.1847 85.156 70.9561 85.3883 72.4081L84.488 72.6114C83.9072 70.6657 83.1522 69.388 81.6712 68.7781C80.9161 68.4296 79.8707 68.2844 78.7672 68.2844C73.8884 68.2844 71.362 72.1758 71.362 76.6189C71.362 82.2236 74.5854 85.8233 78.9995 85.8233C81.9616 85.8233 83.3845 84.4584 84.8656 81.5544L85.7368 81.8448V81.8461Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.248 27H58.944V58.944H27V61.056H58.944V93H61.056V61.056H93V31.752C93 29.1278 90.8722 27 88.248 27Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8914 46.8065L65.2948 48.3245H65.9429V48.7548H64.3945V48.3245H64.7734L67.2009 42.1509H67.7196L70.1458 48.3245H70.5233V48.7548H68.5671V48.3245H69.1597L68.5618 46.8065H65.8927H65.8914ZM66.0604 46.3762H68.3902L67.2246 43.4115L66.0604 46.3762Z",
    fill: "#010000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6909 45.8889V48.3243H73.3404V48.7547H71.1201V48.3243H71.7696V42.6906H71.1201V42.2603H73.4235C74.1548 42.2603 74.7026 42.3962 75.0669 42.6668C75.4312 42.9374 75.6134 43.3453 75.6134 43.8905C75.6134 44.3327 75.5012 44.7049 75.2755 45.0072C75.0498 45.3095 74.7118 45.5405 74.2617 45.7015L75.9949 48.323H76.478V48.7533H75.1329L73.3549 45.8889H72.6922H72.6909ZM72.6909 45.4586H72.9668C73.5252 45.4586 73.9436 45.3306 74.2221 45.0732C74.4993 44.8171 74.6392 44.433 74.6392 43.9221C74.6392 43.4496 74.5138 43.1262 74.2617 42.9519C74.0096 42.7777 73.541 42.6906 72.8533 42.6906H72.6909V45.4586Z",
    fill: "#010000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3767 42.7473H77.5076V43.5024H77.0205V42.2603H82.6543V43.5024H82.1672V42.7473H80.2981V48.3243H80.9475V48.7547H78.7273V48.3243H79.3767V42.7473Z",
    fill: "#010000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.323 48.5382C86.7725 48.7546 86.2683 48.8629 85.8089 48.8629C85.1133 48.8629 84.547 48.6266 84.1114 48.154C83.6758 47.6815 83.458 47.0703 83.458 46.3206C83.458 45.5708 83.6534 45.0177 84.0454 44.5623C84.4374 44.1069 84.9404 43.8799 85.5542 43.8799C86.1218 43.8799 86.5587 44.0713 86.8636 44.4541C87.1698 44.8369 87.3216 45.386 87.3216 46.0988V46.2612H84.3728C84.3728 46.8882 84.51 47.3792 84.7859 47.7343C85.0618 48.0894 85.4433 48.2662 85.933 48.2662C86.4227 48.2662 86.8676 48.1408 87.3216 47.8887V48.5382H87.323ZM84.4308 45.8269H86.4056V45.7173C86.4056 44.7788 86.1059 44.3089 85.5066 44.3089C85.1793 44.3089 84.9258 44.4356 84.7476 44.6877C84.5694 44.9398 84.4638 45.32 84.4322 45.8269H84.4308Z",
    fill: "#010000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_157_413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 39,
    width: 3,
    height: 2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6097 39.7577C66.5899 40.1959 66.9292 40.5668 67.3674 40.5853C67.8056 40.6051 68.1766 40.2659 68.195 39.8276C68.2135 39.3894 67.8743 39.0185 67.436 39C67.4242 39 67.4123 39 67.4004 39C66.978 39 66.6269 39.3326 66.6084 39.759",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5962 38.9268L66.5225 40.6016L68.2144 40.676L68.2881 39.0012L66.5962 38.9268Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_157_413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 39,
    width: 3,
    height: 2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5238 39.7577C72.504 40.1959 72.8432 40.5668 73.2815 40.5853C73.7197 40.6051 74.0906 40.2659 74.1091 39.8276C74.1276 39.3894 73.7883 39.0185 73.3501 39C73.3382 39 73.3263 39 73.3145 39C72.8921 39 72.5409 39.3326 72.5225 39.759",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5093 38.9263L72.4355 40.6011L74.1275 40.6755L74.2012 39.0008L72.5093 38.9263Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_157_413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 39,
    width: 3,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8397 39.7577C78.8199 40.1959 79.1604 40.5668 79.5987 40.5853C80.0369 40.6051 80.4078 40.2659 80.4263 39.8276C80.4461 39.3894 80.1069 39.0185 79.6686 39C79.6568 39 79.6449 39 79.633 39C79.2106 39 78.8595 39.3326 78.8397 39.759",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8257 38.9258L78.752 40.6006L80.4439 40.675L80.5176 39.0003L78.8257 38.9258Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_157_413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 39,
    width: 3,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9012 39.7577C84.8814 40.1959 85.2207 40.5668 85.6589 40.5853C86.0971 40.6038 86.4681 40.2659 86.4865 39.8276C86.5063 39.3894 86.1658 39.0185 85.7289 39C85.717 39 85.7051 39 85.6932 39C85.2708 39 84.9197 39.3326 84.9012 39.759",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_157_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8862 38.9268L84.8125 40.6016L86.5044 40.676L86.5781 39.0012L84.8862 38.9268Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5,
    width: 65,
    height: 65,
    rx: 3.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_413",
    x: 35.0596,
    y: 67.6309,
    width: 15.7812,
    height: 26.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_157_413",
    x: 64.3418,
    y: 67.21,
    width: 25.3945,
    height: 27.7183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_413",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.1a5e15e050e44ecb32730b5ac46d6a2e.svg";
export { ForwardRef as ReactComponent };